import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	modalTitle: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.title',
		defaultMessage: 'We recommend these for you',
		description: 'Title of the template recommendation modal',
	},
	modalSubtitle: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.subtitle',
		defaultMessage: 'Skip the setup and jump into a template to get started.',
		description: 'Subtitle explaining the purpose of the template modal',
	},
	startBlankDoc: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.start-blank-doc',
		defaultMessage: 'Start blank doc',
		description: 'Button label to start with a blank document',
	},
	viewMoreTemplates: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.view-more-templates',
		defaultMessage: 'View more templates',
		description: 'Link to view all available templates',
	},
	closeModal: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.close',
		defaultMessage: 'Close',
		description: 'Aria label for close button',
	},
	buttonUseTemplate: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.use-template',
		defaultMessage: 'Use template',
		description: 'Button label to use the recommended template',
	},
	closeModalLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.close-label',
		defaultMessage: 'Close modal',
		description: 'Aria label for close button',
	},
	startBlankDocLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.start-blank-doc-label',
		defaultMessage: 'Start blank document',
		description: 'Aria label for start blank doc icon',
	},
	viewMoreTemplatesLabel: {
		id: 'experiment-cfind-5291-template-touchpoint.modal.view-more-templates-label',
		defaultMessage: 'View more templates',
		description: 'Aria label for view more templates icon',
	},
	whiteboardTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.whiteboard.template',
		defaultMessage: 'Whiteboard',
		description: 'Label for whiteboard content type on template cards and in template data',
	},
	pageTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.page.template',
		defaultMessage: 'Page',
		description: 'Label for page content type on template cards and in template data',
	},
	livePageTemplateType: {
		id: 'experiment-cfind-5291-template-touchpoint.livepage.template',
		defaultMessage: 'Doc',
		description: 'Label for live page content type on template cards and in template data',
	},
});
